import styled from "styled-components";

const getBackground = (image) =>
  image ? `url(${image}) no-repeat center center` : "white";

export const MiniModalContainer = styled.div`
  position: fixed;
  bottom: ${(props) => (props.isAtBottom ? "250px" : "20px")};
  left: 1px;
  width: 360px;
  height: 260px;
  background: ${(props) => getBackground(props.backgroundImage)};
  background-size: cover;
  border-radius: 0px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  z-index: 9990;
  transition: transform 0.5s ease, box-shadow 0.3s ease, bottom 0.3s ease;
  overflow: hidden;
  backface-visibility: hidden;
  transform: ${(props) =>
    props.isVisible ? "translateX(0)" : "translateX(-100%)"};
  @media (max-height: 310px) {
    display: none;
  }
  @media (max-width: 1366px) {
    width: 330px;
    height: 240px;
    left: 1px;
  }
  @media (max-width: 1280px) {
    width: 225px;
    height: 165px;
    left: 1px;
  }
  @media (max-width: 1024px) {
    width: 270px;
    height: 195px;
    left: 1px;
  }
  @media (max-width: 853px) {
    width: 225px;
    height: 165px;
    left: 1px;
  }
  @media (max-width: 768px) {
    width: 215px;
    height: 155px;
    left: 1px;
  }
  @media (max-width: 430px) {
    width: 225px;
    height: 165px;
    left: 1px;
  }
  @media (max-width: 375px) {
    width: 225px;
    height: 165px;
    left: 1px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: -6px;
  right: -4px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #fff;
  transition: color 0.3s ease;
  z-index: 9991;
  will-change: color;
  transform: translateZ(0);
  backface-visibility: hidden;
  user-select: none;

  &:hover {
    color: #f39200;
  }
`;

export const AproveiteLogo = styled.button`
  background: #f39200;
  color: white;
  padding: 5px 5px;
  border: none;
  border-radius: 0px;
  font-size: 15px;
  cursor: pointer;
  display: block;
  margin: 0 auto;
  position: absolute;
  bottom: 20px;
  left: -70px;
  transform: translateX(50%);
  transition: all 0.2s ease;
  will-change: transform, background-color;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  backface-visibility: hidden;
  user-select: none;
  width: 180px;
  line-height: 1.2;
  @media (max-width: 1366px) {
    font-size: 14px;
    bottom: 20px;
    right: 200px;
    width: 140px;
  
  }
  @media (max-width: 1024px) {
    font-size: 12px;
    bottom: 20px;
    padding: 3px 7px;
    right: 160px;
    width: 130px;
  }
  @media (max-width: 853px) {
    bottom: 20px;
    padding: 4px 10px;
    font-size: 9px;
    right: 120px;
    width: 100px;
  }
  @media (max-width: 540px) {
    bottom: 20px;
    padding: 3px 8px;
    font-size: 9px;
    right: 130px;
    width: 110px;
  }
  @media (max-width: 430px) {
    bottom: 20px;
    padding: 3px 10px;
    font-size: 10px;  
    right: 130px;
    width: 110px;
  }
  @media (max-width: 375px) {
    bottom: 20px;
    padding: 3px 10px;
    font-size: 10px;
    right: 130px;
    width: 110px;
  }
  &:hover {
    background: #e65c00;
    transform: translateX(50%) scale(1.05);
  }
`;
